module.exports = __webpack_public_path__ + "static/media/S (88).4da4c4da.jpg";